import * as React from "react";
import { forwardRef } from "react";
const SvgIcPlayerPrevious32 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icPlayer-previous-32" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M10 7L11 8V14.3507L23.5 7.13379L25 7.99981V22.8357L23.5 23.7018L11 16.4849V23L10 24H8L7 23V8L8 7H10Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcPlayerPrevious32);
export { ForwardRef as ReactComponent };
